import { addBreadcrumb, captureException, captureMessage } from '@sentry/react';
import { LOGGER_SPACIAL_SYMBOL } from '../config';
import { sentryScopeSet } from '../sentry';

const SUPPORTED_LIST: string[] = [LOGGER_SPACIAL_SYMBOL.BASIC, LOGGER_SPACIAL_SYMBOL.GLOBAL];

/**
 * 处理 logger 收集到的信息并发送 sentry
 * @param module
 * @param desc
 * @param error
 */
export const handleSentryCaptureError = (module: string, desc: string, error: unknown) => {
	if (!SUPPORTED_LIST.includes(module)) {
		return;
	}
	switch (module) {
		case LOGGER_SPACIAL_SYMBOL.BASIC:
		case LOGGER_SPACIAL_SYMBOL.GLOBAL:
		case LOGGER_SPACIAL_SYMBOL.EVENT_LOGGER:
		case LOGGER_SPACIAL_SYMBOL.PAYMENT:
		case LOGGER_SPACIAL_SYMBOL.PARAM_ERROR: {
			sentryScopeSet(() => {
				addBreadcrumb({
					level: 'error',
					category: `${module}`,
					message: `${desc}`,
					data: { error },
				});

				captureException(error);
			});
			break;
		}

		case LOGGER_SPACIAL_SYMBOL.BUSINESS_ERROR: {
			sentryScopeSet(() => {
				addBreadcrumb({
					level: 'info',
					category: `${module}`,
					message: `${desc}`,
					data: { error },
				});

				captureMessage(desc, 'info');
			});
			break;
		}

		default: {
			sentryScopeSet(() => {
				addBreadcrumb({
					level: 'warning',
					category: `${module}`,
					message: `${desc}`,
					data: { error },
				});

				captureMessage(desc, 'warning');
			});
			break;
		}
	}
};

// 添加到 window 给 Android 调用（for 线上 bug 排查），使用完后请置空
(window as any).handleSentryCaptureError = handleSentryCaptureError;
// (window as any).handleSentryCaptureError = () => {};
